import * as z from "zod";

const state = z.enum(["InProgress", "Active"]);
const subState = z.enum(["Reserved", "Released", "Downloaded"]);

export const qrCode = z.object({
  subState,
  matchingId: z.string(),
  iccid: z.string(),
  state,
});

export const serverResponse = z.array(qrCode);
export type IEsimQRCode = z.infer<typeof qrCode>;
